function TopBar({title}) {

const username =
localStorage.getItem("username");

const email =
localStorage.getItem("email");

const logout=()=>{

localStorage.clear();

window.location.reload();

};

return(

<nav
className="navbar navbar-light bg-white sticky-top shadow-sm px-3"
style={{
minHeight:"55px"
}}
>

<div className="container-fluid">

<div
className="navbar-brand fw-bold"
>

SaleUpCall

</div>

<div
className="dropdown ms-auto"
>

<button
className="btn border-0 bg-transparent dropdown-toggle d-flex align-items-center"
type="button"
data-bs-toggle="dropdown"
>

<i
className="bi bi-person-circle me-2"
style={{
fontSize:"28px"
}}
></i>

<div
className="text-start me-2"
>

<div
className="fw-bold"
style={{
fontSize:"14px",
lineHeight:"14px"
}}
>

{username}

</div>

<small
className="text-muted"
style={{
fontSize:"11px"
}}
>

{email}

</small>

</div>

</button>

<ul
className="dropdown-menu dropdown-menu-end"
>

<li>

<button
className="dropdown-item text-danger"
onClick={logout}
>

<i className="bi bi-box-arrow-right me-2"></i>

Logout

</button>

</li>

</ul>

</div>

</div>

</nav>

);

}

export default TopBar;